$(document).ready(function () {
    //HEADER DROPDOWN SCRIPT START
    $('.header .navbar-nav .dropdown').hover(function (e) {
        $(this).addClass('dropdown-menu-show');
        // var eleOffset = $('.dropdown-submenu-item').offset();
        // $(".dropdown-item-list").find('.dropdown-menu').css({
        //     "position": "fixed",
        //     "top": eleOffset.top - 6 + 'px',
        //     "left": eleOffset.left + $('.dropdown-menu').outerWidth() - 5 + 'px'
        // });
    }, function () {
        $(this).removeClass('dropdown-menu-show');
    });
    //HEADER DROPDOWN SCRIPT END
    //HEADER DROPDOWN SCRIPT START
    // $('.header .navbar-nav .dropdown').hover(function () {
    //     $(this).addClass('show').find('.dropdown-menu').stop(true, true).fadeIn('fast');
    // }, function () {
    //     $(this).removeClass('show').find('.dropdown-menu').stop(true, true).fadeOut('fast');
    // });
    //HEADER DROPDOWN SCRIPT END

    //DROPDOWN KEEP OPEN SCRIPT START
    $('.dropdown-menu.keep-open,.export-dropdown .dropdown-menu').on('click', function (e) {
        e.stopPropagation();
    });
    //DROPDOWN KEEP OPEN SCRIPT END

    $('#tr_theme').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
        return false;
    });
    
});
